module.exports = __webpack_public_path__ + "8cd54ac5034cc78ccd74bc44a7481324.svg";